/**
 * Accordion - Interactive expandable content sections
 * Provides keyboard navigation and WAI-ARIA APG accordion pattern compliance.
 */

class Accordion {
  constructor(container) {
    this.$container = $(container);
    this.$triggers = this.$container.find('.accordion-trigger');
    this.$panels = this.$container.find('.accordion-panel');

    this.bindEvents();
  }

  bindEvents() {
    this.$triggers.on('click', (e) => {
      this.toggle($(e.currentTarget));
    });

    this.$triggers.on('keydown', (e) => {
      const $current = $(e.currentTarget);
      const index = this.$triggers.index($current);
      let targetIndex = null;

      switch (e.key) {
        case 'ArrowDown':
          targetIndex = (index + 1) % this.$triggers.length;
          break;
        case 'ArrowUp':
          targetIndex = (index - 1 + this.$triggers.length) % this.$triggers.length;
          break;
        case 'Home':
          targetIndex = 0;
          break;
        case 'End':
          targetIndex = this.$triggers.length - 1;
          break;
        default:
          return;
      }

      e.preventDefault();
      this.$triggers.eq(targetIndex).focus();
    });
  }

  toggle($trigger) {
    const isExpanded = $trigger.attr('aria-expanded') === 'true';
    const panelId = $trigger.attr('aria-controls');
    const $panel = $('#' + panelId);
    const title = $trigger.clone().children().remove().end().text().trim();

    if (isExpanded) {
      $trigger.attr('aria-expanded', 'false');
      $panel.attr('hidden', '');
      this.announce(title + ' collapsed');
    } else {
      $trigger.attr('aria-expanded', 'true');
      $panel.removeAttr('hidden');
      this.announce(title + ' expanded');
    }
  }

  announce(message) {
    const $announcer = this.$container.find('.sr-announcer');
    $announcer.text(message);
  }
}

/**
 * Initialize accordion groups on the page
 * @param {string} selector - jQuery selector for the container(s)
 */
export function initAccordion(selector) {
  $(selector).each(function() {
    if ($(this).data('accordion-initialized')) return;

    const instance = new Accordion(this);
    $(this).data('accordion-instance', instance);
    $(this).data('accordion-initialized', true);
  });
}

export { Accordion };
